module.exports = __webpack_public_path__ + "static/woman-l-74b616e3769772dbc90358649fc62334.jpg";